import React from 'react'
import { StateProvider } from '../stores/graphics_menu'
import Search from './GraphicsMenu/Search'
import Select from './GraphicsMenu/Select'

export default function GraphicsMenu(props) {
  return (
    <div className="position-relative">
      <StateProvider {...props}>
        <Search />
        <Select />
      </StateProvider>
    </div>
  )
}
